const isPlausibleMonthDay = (month, day) => {
   const mm = Number(month),
      dd = Number(day);
   return mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31;
};

const leftPad2 = (numberLike) => {
   return String(numberLike).padStart(2, "0");
};

const formatISO = (year, month, day) => {
   return `${year}-${leftPad2(month)}-${leftPad2(day)}`;
};

export function looksLikeDateValue(value) {
   const input = String(value ?? "").trim();
   if (!input) return false;

   // scope "X - Y"
   if (/^.+\s*-\s*.+$/.test(input)) return true;

   // ISO with/without time
   if (/^\d{4}-\d{2}-\d{2}(?:[ T].*)?$/.test(input)) return true;

   // YYYY[.-/]MM[.-/]DD  /  DD[.-/]MM[.-/]YYYY
   if (/^\d{4}([.\-\/])\d{2}\1\d{2}$/.test(input)) return true;
   if (/^\d{2}([.\-\/])\d{2}\1\d{4}$/.test(input)) return true;

   // YYYYMMDD or DDMMYYYY
   if (/^\d{8}$/.test(input)) return true;

   return false;
}

export function normalizeDateValue(value) {
   const input = String(value ?? "").trim();
   if (!input) return value;

   // Scope "X - Y"
   if (/^.+\s*-\s*.+$/.test(input)) {
      const [rawFrom, rawTo] = input.split(/\s*-\s*/);
      const fromNormalized = normalizeDateValue(rawFrom);
      const toNormalized = normalizeDateValue(rawTo);
      return `${fromNormalized} - ${toNormalized}`;
   }

   // ISO ( YYYY-MM-DD, without time)
   const isoDateOnlyMatch = /^(\d{4}-\d{2}-\d{2})(?:[ T].*)?$/.exec(input);
   if (isoDateOnlyMatch) return isoDateOnlyMatch[1];

   // YYYY[.-/]MM[.-/]DD
   let parts = /^(\d{4})([.\-\/])(\d{2})\2(\d{2})$/.exec(input);
   if (parts) {
      const year = parts[1],
         month = parts[3],
         day = parts[4];
      return formatISO(year, month, day);
   }

   // DD[.-/]MM[.-/]YYYY
   parts = /^(\d{2})([.\-\/])(\d{2})\2(\d{4})$/.exec(input);
   if (parts) {
      const day = parts[1],
         month = parts[3],
         year = parts[4];
      return formatISO(year, month, day);
   }

   // 8 digits: try YYYYMMDD and DDMMYYYY
   const eightDigits = /^(\d{8})$/.exec(input)?.[1];
   if (eightDigits) {
      const ymdYear = eightDigits.slice(0, 4);
      const ymdMonth = eightDigits.slice(4, 6);
      const ymdDay = eightDigits.slice(6, 8);

      const dmyDay = eightDigits.slice(0, 2);
      const dmyMonth = eightDigits.slice(2, 4);
      const dmyYear = eightDigits.slice(4, 8);

      const ymdIsPlausible = isPlausibleMonthDay(ymdMonth, ymdDay);
      const dmyIsPlausible = isPlausibleMonthDay(dmyMonth, dmyDay);

      if (dmyIsPlausible && !ymdIsPlausible) return formatISO(dmyYear, dmyMonth, dmyDay);
      if (ymdIsPlausible && !dmyIsPlausible) return formatISO(ymdYear, ymdMonth, ymdDay);
      if (dmyIsPlausible && ymdIsPlausible) return formatISO(dmyYear, dmyMonth, dmyDay);

      return value;
   }

   return value;
}
